import { EType } from '../../repositories/newbuilding-promos/entities/json_query/IntTermFieldSchema';
import { ITagSchema } from '../../repositories/newbuilding-promos/entities/tag/TagSchema';

export const getTagsMk = (): ITagSchema[] => {
  return [
    {
      name: 'ЖК Москвичка',
      jsonQuery: {
        newbuildingIds: {
          type: EType.Term,
          value: [1],
        },
      },
    },
  ];
};
